export default {
  LIST(state, data) {
    state.students = data
  },
  GET(state, data) {
    state.student = {
      ...data,
    }
  },
  UPDATE(state, value) {
    const data = {
      id: value.id,
      dc_type: value.dc_type,
      scientific_work_name: value.scientific_work_name,
      direction: value.direction,
      edu_lang: value.edu_lang,
      quarter: null,
      period: null,
      user: value.user,
      course: value.course,
      direction_second: value.direction_second ? value.direction_second.id : null,
    }
    const { quarter } = value
    if (quarter) {
      data.quarter = quarter.quarter
      data.period = quarter.period.admission_year
    }
    data.direction = value.direction.id
    data.pnfl = value.user.pin
    state.student = {
      ...data,
    }
  },
  UPDATE_COURSE(state, data) {
    const { id, course, scientific_work_name } = data
    const pnfl = data.user.pin
    state.student = {
      id, course, scientific_work_name, pnfl, state: data.state,
    }
  },

  DIRECTIONS(state, data) {
    state.directions = data
  },
  FRESH(state) {
    state.student = {
      id: null,
      dc_type: null,
      edu_lang: null,
      status: 100,
      scientific_work_name: '',
      reject_info: '',
      organization: null,
      direction: null,
      scientific_works: {},
      user: {},
      course: null,
      direction_second: null,
    }
  },
}
